import { Link } from 'react-router-dom'

type AuthFooterLinksProps = {
  showSignIn?: boolean
  compact?: boolean
}

export default function AuthFooterLinks({ showSignIn, compact }: AuthFooterLinksProps) {
  const linkClass = compact
    ? 'text-[0.875rem] text-gray-800 hover:text-gray-900'
    : 'text-[18px] text-gray-800 hover:text-gray-900'
  return (
    <div className={compact ? 'mt-[1rem] flex items-center justify-center gap-[1rem] text-[0.875rem]' : 'mt-4 flex items-center justify-center gap-4 text-[18px]'}>
      <a
        href="/assets/auth/files/Dashboard-Insights-Privacy-Policy.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className={linkClass}
      >
        Privacy Policy
      </a>
      <a
        href="/assets/auth/files/Dashboard-Insights-Terms-and-Conditions.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className={linkClass}
      >
        Terms &amp; Conditions
      </a>
      {showSignIn && (
        <Link to="/login" className={linkClass}>
          Sign in
        </Link>
      )}
    </div>
  )
}
